// Product Subtotal Calculator (guarded to avoid redeclaration during section re-renders)
if (typeof window.ProductSubtotal === 'undefined') {
  class ProductSubtotal {
    constructor() {
      this.subtotalElement = document.querySelector('.product__subtotal-price');
      this.quantityInput = document.querySelector('quantity-input input');
      
      if (this.subtotalElement && this.quantityInput) {
        this.basePrice = parseFloat(this.subtotalElement.dataset.price);
        this.init();
      }
    }

    init() {
      // Listen for quantity changes
      this.quantityInput.addEventListener('change', () => this.updateSubtotal());
      
      // Listen for variant changes from product-form.js
      // Subscribe to pubsub variantChange event instead of legacy DOM event
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        this.variantUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
          const variant = data?.variant;
          if (variant) {
            this.basePrice = variant.price;
            this.subtotalElement.dataset.price = variant.price;
            this.updateSubtotal();
          }
        });
      }
      
      // Update on page load
      this.updateSubtotal();
    }

    updateSubtotal() {
      const quantity = parseInt(this.quantityInput.value) || 1;
      const subtotal = this.basePrice * quantity;
      
      // Format price using Shopify's money format
      const formattedPrice = this.formatMoney(subtotal);
      this.setSubtotalHTML(formattedPrice);
    }

    formatMoney(cents) {
      // Get Shopify money format from theme settings or use default numeric-only
      const moneyFormat = window.theme?.moneyFormat || '{{amount}}';
      const value = (cents / 100).toFixed(2);
      return moneyFormat.replace('{{amount}}', value);
    }

    // Safely update DOM so that when price HTML uses the .price-wrapper structure
    // we only replace the numeric portion inside .price-amount (keeps icon intact)
    setSubtotalHTML(formattedPrice) {
      if (!this.subtotalElement) return;

      const amountEl = this.subtotalElement.querySelector && this.subtotalElement.querySelector('.price-amount');
      if (amountEl) {
        amountEl.textContent = formattedPrice;
      } else {
        this.subtotalElement.textContent = formattedPrice;
      }
    }
  }

  window.ProductSubtotal = ProductSubtotal;
}

// Initialize when DOM is ready (guarded to prevent duplicate instances)
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    if (!window.__productSubtotalInstance) {
      window.__productSubtotalInstance = new window.ProductSubtotal();
    }
  });
} else {
  if (!window.__productSubtotalInstance) {
    window.__productSubtotalInstance = new window.ProductSubtotal();
  }
}
